export enum LS_KEYS {
  compares = "compares",
  likes = "likes",
  settings = "settings",
}
